import React, { useEffect } from "react";
import moment from "moment";
import * as XLSX from "xlsx";

import PeriodeFilter from "./PeriodeFilter";
import LevelFilter from "./LevelFilter";
import ActionButtons from "./ActionButtons";
import { UserLevel } from "utils/constant";
import { boolean } from "yup";

const FilterSection = ({
  currentUser,
  periodeLaporan,
  setPeriodeLaporan,
  periodeLaporanValue,
  setPeriodeLaporanValue,
  selectedLevel,
  setSelectedLevel,
  levelData,
  levelDataOptions,
  setLevelIdValue,
  selectedProvince,
  setSelectedProvince,
  selectedDistrict,
  setSelectedDistrict,
  selectedFasyankes,
  setSelectedFasyankes,
  handleApplyFilter,
  tableRef,
  showData,
  showFilter,
  setShowFilter,
  levelIdValue,
  reportName = "LAPORAN",
}) => {
  useEffect(() => {
    if (currentUser.level === UserLevel.Fasyankes) {
      setLevelIdValue(currentUser?.fasyankes_id);
    } else if (currentUser.level === UserLevel.District) {
      setSelectedFasyankes("");
      setLevelIdValue(currentUser?.district_id);
    } else if (currentUser.level === UserLevel.Province) {
      setSelectedDistrict("");
      setSelectedFasyankes("");
      setLevelIdValue(currentUser?.province_id);
    } else if (currentUser.level === UserLevel.National) {
      setSelectedProvince("");
      setSelectedDistrict("");
      setSelectedFasyankes("");
    } else {
      setLevelIdValue("");
    }
  }, [selectedLevel]);

  const level =
    selectedLevel === UserLevel.National
      ? UserLevel.National
      : levelIdValue?.split("|")[1];

  const exportToExcel = () => {
    const table = tableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: "Sheet 1" });

    // Ambil worksheet pertama
    const ws = wb.Sheets["Sheet 1"];

    // Misalnya kolom NIP/KTP ada di kolom F
    // Loop semua cell di kolom F mulai dari row 2
    Object.keys(ws).forEach((cell) => {
      if (cell.startsWith("F") && cell !== "F5") {
        // "D" = kolom NIP/KTP
        ws[cell].z = "@"; // Format text
        ws[cell].t = "s"; // Paksa jadi string
        ws[cell].v = String(ws[cell].v); // Pastikan nilainya string
      }
    });

    XLSX.writeFile(
      wb,
      `${reportName}_${level}_${moment().format("DDMMYYYY")}.xlsx`
    );
  };

  const isPeriodeValid =
    periodeLaporanValue &&
    ((periodeLaporan === "monthly" &&
      Object.keys(periodeLaporanValue).length > 1) ||
      (periodeLaporan === "yearly" &&
        Object.keys(periodeLaporanValue).length > 0));

  const isLevelValid =
    (selectedLevel === UserLevel.Fasyankes && !!selectedFasyankes) ||
    (selectedLevel === UserLevel.District && !!selectedDistrict) ||
    (selectedLevel === UserLevel.Province && !!selectedProvince) ||
    selectedLevel === UserLevel.National;

  const isEnableButton = isPeriodeValid && isLevelValid;

  return (
    <div className="filter">
      <div className="filter-header">
        <p>FILTER</p>
        <button
          className="btn_toggle_filter"
          onClick={() => setShowFilter(!showFilter)}
        >
          {showFilter ? <span>&#9650;</span> : <span>&#9660;</span>}
        </button>
      </div>
      {showFilter && (
        <div className="filter-body">
          <div className="filter-item">
            <div className="filter-label">
              <p>Periode Laporan</p>
            </div>
            <div className="filter-field">
              <PeriodeFilter
                periodeLaporan={periodeLaporan}
                setPeriodeLaporan={setPeriodeLaporan}
                periodeLaporanValue={periodeLaporanValue}
                setPeriodeLaporanValue={setPeriodeLaporanValue}
                selectedLevel={selectedLevel}
              />
            </div>
          </div>
          <div className="filter-item">
            <div className="filter-label">
              <p>Level</p>
            </div>
            <div className="filter-field">
              <LevelFilter
                currentUser={currentUser}
                selectedLevel={selectedLevel}
                setSelectedLevel={setSelectedLevel}
                levelData={levelData}
                levelDataOptions={levelDataOptions}
                setLevelIdValue={setLevelIdValue}
                selectedProvince={selectedProvince}
                setSelectedProvince={setSelectedProvince}
                selectedDistrict={selectedDistrict}
                setSelectedDistrict={setSelectedDistrict}
                selectedFasyankes={selectedFasyankes}
                setSelectedFasyankes={setSelectedFasyankes}
              />
            </div>
          </div>
          <div className="filter-item">
            <div className="filter-field">
              <ActionButtons
                onApply={handleApplyFilter}
                onExport={exportToExcel}
                isExportVisible={showData}
                isDisabled={!isEnableButton}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterSection;
